import Chip from '@mui/material/Chip';
import React from 'react';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import Grid from '@mui/material/Grid';
import RefreshIcon from '@mui/icons-material/Refresh';
import BugReportIcon from '@mui/icons-material/BugReport';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { useState, useEffect} from 'react';
import { DataGrid, GridColDef, GridToolbar, gridDateComparator } from '@mui/x-data-grid';
import DataObjectIcon from '@mui/icons-material/DataObject';
import DocumentLogs from './DocumentLogs';
import { HOST } from '../components/config';
import { JsonEditor } from 'json-edit-react'

function ReviewFileLogs(props) { 
  const [fileProcessingInfo, setFileProcessingInfo] = useState([])
  const [pendingOutputViewResultJson, setPendingOutputViewResultJson] = useState(null)

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    display:'block',
    overflow:'scroll',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    height: '80%',
  border: '1px solid grey[200]',
  boxShadow: '0 4px 12px rgb(0 0 0 / 0.2)',
  bgcolor: 'background.paper',
    borderRadius: 2,
    p: 4,
  };
  
  const fetchFileProcessingResults = async (file_id) => {
      try {
        const response = await fetch(HOST + '/api/file_processing_step_results/?file_id=' + file_id, { 
          "headers": { 
            'Authorization': 'Bearer ' + localStorage.getItem('token')
          }
        });
        const json = await response.json()
        setFileProcessingInfo(json)
      } catch (err) {
      }   
  }

  const fetchRunInfo = async (id) => {
      try {
        const response = await fetch(HOST + '/api/file_processing_step_result_runs/' + id, { 
          "headers": { 
            'Authorization': 'Bearer ' + localStorage.getItem('token')
          }
        });
        const json = await response.json()
        return json
      } catch (err) {
      }   
  }
  
  const fetchLastRunInfo = async (id) => {
      try {
        const response = await fetch(HOST + '/api/file_processing_step_result_runs?file_processing_step_result_id=' + id, { 
          "headers": { 
            'Authorization': 'Bearer ' + localStorage.getItem('token')
          }
        });
        const json_list = await response.json()
        const last_id = json_list[json_list.length - 1].id
        const json = await fetchRunInfo(last_id)
        const res_output = await fetch(json.download_url)
        window.open(json.download_url, '__blank')
        return
        const output = await res_output.json()
        console.log(output)
        setPendingOutputViewResultJson(output)
      } catch (err) {
      }   
  }
  
  const handleRerunStep= (resultId) => {
    fetch(HOST + '/api/file_processing_step_results/' + resultId + "/reprocess/",
    {   
      "method": "POST",
      "headers" : { 
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/json'
        },  
     })
    .then((res) => res.json())
    .then((json) => {
      
   })
  }
  
  const getStatusChip = (item) => { return(item.status == 'SUCCESS' ? 
        (<Chip  className="chip-boxy"  label="Success" color="success" variant="" />) : 
        item.status.includes('ERROR') ?  
        (<Chip  className="chip-boxy" label={item.status} color="error" variant="" />) :
        item.status.includes('PREPARE') ?  
        (<Chip  className="chip-boxy"  label="Waiting to run" color="warning" variant="" />) : 
        (<Chip  className="chip-boxy"  label="Running" color="info" variant="" />)) 
  }
  
  const processingColumns: GridColDef[] = [
    { 
      field: 'type', 
      headerName: 'Stage', 
      width: 100,
      valueGetter: (value, row) => row.processing_step_label
    },
    { 
      field: 'updated_at', 
      headerName: 'Updated At', 
      width: 180,
      type: 'datetime',
      valueFormatter: (d_s) => d_s.toLocaleString(),
      valueGetter: (value, row) => new Date(row.updated_at)
    },
    { 
      field: 'status', 
      headerName: 'Status', 
      width: 120,
      renderCell: (params) => getStatusChip(params.row) 
    },
    {
      field: 'action',
      headerName: 'Actions',
      width: 250,
      sortable: false,
      renderCell: (params) =>  (
      <>
        <IconButton onClick={() => handleRerunStep(params.row.id)}
          size='md' >
          <RefreshIcon /> 
        </IconButton> 
        <IconButton onClick={() => fetchLastRunInfo(params.row.id)}
          size='md' >
          <DataObjectIcon />
        </IconButton> 
        <IconButton onClick={() => setPendingOutputViewResultJson(params.row.error)}
          disabled={!params.row.error}
          size='md' >
          <BugReportIcon />
        </IconButton> 
    </>)
    },
  ];
  
  const paginationModel = { page: 0, pageSize: 10 };
  
  useEffect( () => {
    setFileProcessingInfo({})
    setPendingOutputViewResultJson(null)
    fetchFileProcessingResults(props.info.id)
    const intervalId = setInterval(() => { 
      fetchFileProcessingResults(props.info.id)
      
      }, 5000); // Poll every 5 seconds
    
    return () => {
      clearInterval(intervalId); // Clear interval on unmount
    };
  }, [props.info.id])
  
  return (<>
            { true && pendingOutputViewResultJson != null &&
            <Box >
              <JsonEditor
                data={ pendingOutputViewResultJson}
              />
            </Box>
            }
              <DataGrid
                rows={fileProcessingInfo}
                columns={processingColumns}
                initialState={{ sorting: { sortModel: [ { field: "added_on", sort: 'desc' }]}, columns: { columnVisibilityModel: { 'pre_processing': true}}, pagination: { paginationModel } }}
                pageSizeOptions={[10, 25, 50, 100]}
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    printOptions: { disableToolbarButton: true },
                    csvOptions: { disableToolbarButton: true },
                    showQuickFilter: true,
                  },
                }}
                disableRowSelectionOnClick
                sx={{ border: 0 }}
              />
  </>)
}
export default ReviewFileLogs;
